import { render, staticRenderFns } from "./EducationalQualificationDetails.vue?vue&type=template&id=7294ec0e&scoped=true"
import script from "./EducationalQualificationDetails.vue?vue&type=script&lang=ts"
export * from "./EducationalQualificationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294ec0e",
  null
  
)

export default component.exports